import {
  Flex,
  Box,
  Container,
  Center,
  Icon,
  Text,
  Image,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  useDisclosure,
  Button,
} from "@chakra-ui/react";
import { useState } from "react";
import { TfiControlBackward } from "react-icons/tfi";
import { FaReact, FaNodeJs } from "react-icons/fa6";
import {
  SiChakraui,
  SiSequelize,
  SiPostgresql,
  SiLaravel,
  SiAdonisjs,
  SiBootstrap,
  SiJquery,
  SiMongodb,
} from "react-icons/si";
import { TbBrandNextjs, TbBrandReactNative } from "react-icons/tb";
import { FiExternalLink } from "react-icons/fi";
import { GrMysql } from "react-icons/gr";
import { useNavigate } from "react-router-dom";
import port1 from "../assets/porto/porto1.png";
import iyagi from "../assets/porto/iyagi-mock.png";
import eproc from "../assets/porto/eproc_mockup.png";
import webis from "../assets/porto/mocbsnis-rmbg.png";

function ModalPort({ isOpen, onClose, link, desc, title }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent bg="orange.50">
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text mb={4}>{desc}</Text>
        </ModalBody>
        <ModalFooter>
          <Button as="a" href={link} target="_blank" variant="ghost">
            Link
            <FiExternalLink />
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default function PortfolioPage() {
  const [isHovered, setIsHovered] = useState(false);
  const [selectedLink, setSelectedLink] = useState("");
  const [desc, setDesc] = useState("");
  const [title, setTitle] = useState("");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const nav = useNavigate();

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handleOpenModal = (link, desc, title) => {
    setSelectedLink(link);
    setDesc(desc);
    setTitle(title);
    onOpen();
  };

  const projects = [
    {
      id: 1,
      title: "E-Procurement",
      desc: "A complex e-procurement application built with Laravel, designed to streamline procurement processes while adhering to strict guidelines required by MRT Jakarta, a state-owned company. The platform enables efficient management of procurement workflows, ensuring transparency, compliance, and seamless communication between vendors and procurement teams.",
      image: eproc,
      link: "https://eproc.jakartamrt.co.id/",
      icons: [SiLaravel, SiBootstrap, SiJquery, SiPostgresql],
    },
    {
      id: 2,
      title: "Business Division Website",
      desc: "A business and marketing web application built with Next.js for the frontend and AdonisJS as the CMS/backend. The platform is designed to showcase potential business opportunities and partnerships with MRT Jakarta, providing detailed information to attract and engage potential partners. It offers a seamless and interactive experience for businesses looking to explore collaborations, featuring a dynamic content management system for easy updates and information sharing.",
      image: webis,
      link: "https://bisnis.jakartamrt.co.id/",
      icons: [TbBrandNextjs, SiAdonisjs, GrMysql],
    },
    {
      id: 3,
      title: "Iyagi Novels App",
      desc: "Iyagi is a Korean novel reading app built with a React Native mobile application, a React.js-based CMS, and a Node.js backend.",
      image: iyagi,
      link: "https://iyaginovels.com/",
      icons: [TbBrandReactNative, FaReact, FaNodeJs, SiMongodb],
    },
    {
      id: 4,
      title: "Ecommerce Books",
      desc: "A user-friendly book e-commerce platform built with React (Chakra UI), an Express.js backend, and MySQL. It allows users to create and track orders, choose delivery options, upload payment proof, and enables admins to manage sales reports. Features include real-time stock updates and third-party API integration for precise delivery cost calculations.",
      image: port1,
      link: "https://github.com/purwadhikafullstack/jcwd020601",
      icons: [FaReact, SiChakraui, FaNodeJs, GrMysql, SiSequelize],
    },
  ];

  const ProjectCard = ({ project }) => (
    <Flex
      flexDir="column"
      gap="0.3rem"
      cursor="pointer"
      _hover={{ opacity: "0.8" }}
      padding="1rem"
      onClick={() => handleOpenModal(project.link, project.desc, project.title)}
    >
      <Flex height="80%">
        <Image borderRadius="1rem" src={project.image} alt={project.title} />
      </Flex>
      <Flex height="20%" flexDir="column" justifyContent="center">
        <Flex justifyContent="space-between">
          <Text>{project.title}</Text>
          <Flex gap="0.2rem" alignItems="center" fontSize="lg">
            {project.icons.map((IconComponent, index) => (
              <Icon key={index} as={IconComponent} />
            ))}
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );

  return (
    <Box w="100vw" bgColor="#fdfbf5" padding="1rem">
      <Box border="1px solid black">
        <Container
          maxW="1860px"
          padding={{ base: "0 1rem", md: "0 2rem", lg: "0 3rem" }}
        >
          <Flex flexDir="column" gap="1rem">
            <Flex
              width="100%"
              borderBottom="1.5px solid black"
              alignItems="center"
              padding="32px 0"
              justifyContent={"space-between"}
            >
              <Flex
                cursor="pointer"
                alignItems="center"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                onClick={() => nav("/")}
              >
                <Center fontSize="3xl">
                  <Icon as={TfiControlBackward} />
                </Center>
                {isHovered && <Text>Home</Text>}
              </Flex>
              <Text marginRight={"1rem"}>PORTFOLIO</Text>
            </Flex>

            <Flex paddingBottom="1rem" flexDir={{ base: "column", lg: "row" }}>
              <Flex
                width={{ base: "100%", lg: "20%" }}
                borderRight={{ base: "none", lg: "1.5px solid black" }}
                flexDir="column"
                gap="0.5rem"
                fontWeight={{ base: "bold", lg: "normal" }}
              >
                <Center className="font-paragraph" padding="1rem" fontSize="xl">
                  PROJECT EXPERIENCE
                </Center>
              </Flex>

              <Flex
                padding="1rem 2rem"
                width={{ base: "100%", lg: "90%" }}
                flexWrap="wrap"
                alignItems="center"
                justifyContent="center"
                flexDir="column"
              >
                <Flex
                  borderBottom={{ base: "none", lg: "1.5px solid black" }}
                  padding="1rem 0"
                  flexDir={{ base: "column", lg: "row" }}
                  width="100%"
                >
                  {projects.slice(0, 2).map((project, index) => (
                    <Flex
                      key={project.id}
                      borderRight={{
                        base: "none",
                        lg: index === 0 ? "1px solid black" : "none",
                      }}
                      padding="0.5rem"
                      width={{ base: "100%", lg: "50%" }}
                    >
                      <ProjectCard project={project} />
                    </Flex>
                  ))}
                </Flex>

                <Flex
                  padding="1rem"
                  flexDir={{ base: "column", lg: "row" }}
                  width="100%"
                >
                  {projects.slice(2, 4).map((project, index) => (
                    <Flex
                      key={project.id}
                      borderRight={{
                        base: "none",
                        lg: index === 0 ? "1px solid black" : "none",
                      }}
                      padding="0.5rem"
                      width={{ base: "100%", lg: "50%" }}
                    >
                      <ProjectCard project={project} />
                    </Flex>
                  ))}
                </Flex>
              </Flex>
            </Flex>
          </Flex>
          <ModalPort
            isOpen={isOpen}
            onClose={onClose}
            link={selectedLink}
            desc={desc}
            title={title}
          />
        </Container>
      </Box>
    </Box>
  );
}
